import {DefaultScreenDetector} from "./libraries/screen-detector/DefaultScreenDetector";

class FooterMenuHandler {
    constructor() {
        this.activeMenu = null;
        this.mobileMenuInitialized = false;

        const isMobile = DefaultScreenDetector.isMobileView();

        if (isMobile) {
            this.initMobileMenu()
        }

        DefaultScreenDetector.listener.onMobileView(this.initMobileMenu.bind(this));
    }

    initMobileMenu() {
        if (this.mobileMenuInitialized) {
            return;
        }
        this.mobileMenuInitialized = true;

        const headers = this._getHeaderElements();
        for (let header of headers) {
            header.addEventListener('click', this._clickHeaderMenu.bind(this, header));
        }
    }

    _clickHeaderMenu(element) {
        if (false === DefaultScreenDetector.isMobileView()) {
            return;
        }

        const menuGroup = element.parentElement;
        this.activeMenu = this.activeMenu === menuGroup
            ? null
            : menuGroup
        ;

        const headers = this._getHeaderElements();
        for (let header of headers) {
            const menuGroup = header.parentElement;
            menuGroup.classList.remove('expanded');

            if (this.activeMenu === menuGroup) {
                menuGroup.classList.add('expanded');
            }
        }
    }

    _getHeaderElements() {
        const headers = document.querySelectorAll('.footer-menu-header');

        return headers;
    }
}

export function initializeFooter() {
    new FooterMenuHandler();
}